export function resolveWindowTitle(windowTitle?: string): string {
  const trimmed = windowTitle?.trim();
  return trimmed ? trimmed : "Inventory";
}
